import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';
import { resetImportCommands } from './actions';

const CustomPaper = styled(Paper)`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-item: center;
  text-align: center;
  font-size: 1.2em;
  margin-top: 5%;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-item: center;
  justify-content: center;
  margin-top: 40px;
`;

const CreateBatchSuccess = ({
  commands,
  dispatchResetImportCommands,
  productIsInStock,
  history
}) => (
  <>
    <CustomPaper>
      <p>
        Vous avez importé{' '}
        <strong style={{ fontWeight: 700 }}>{commands.length}</strong>{' '}
        commandes.
      </p>
      {productIsInStock ? (
        <p>
          Vous nous avez indiqué que vos produits sont présents dans nos
          entrepôts, vous pouvez retrouver vos commandes dans la partie
          expédition
        </p>
      ) : (
        <p>
          Afin que vos commandes soient traitées vous devez
          <strong style={{ fontWeight: 700, color: '#d9534f' }}>
            &nbsp; impérativement faire une demande de traitement &nbsp;
          </strong>
          sur la page colis prêt.
        </p>
      )}
    </CustomPaper>
    <ButtonContainer>
      <Button
        color="primary"
        variant="contained"
        style={{ marginRight: 30 }}
        onClick={dispatchResetImportCommands}
      >
        Importer un nouveau fichier
      </Button>
      <Button
        color="primary"
        variant="contained"
        style={{ marginLeft: 30 }}
        onClick={() => {
          if (productIsInStock) {
            return history.push('/sent-by-me');
          }
          return history.push('/not-sent');
        }}
      >
        {productIsInStock ? 'Voir mes expéditions' : 'Voir mes colis prêts'}
      </Button>
    </ButtonContainer>
  </>
);

const mapStateToProps = state => ({
  commands: state.importCommands.commands,
  productIsInStock: state.importCommands.productIsInStock
});

const mapDispatchToProps = dispatch => ({
  dispatchResetImportCommands: () => dispatch(resetImportCommands())
});

CreateBatchSuccess.propTypes = {
  commands: PropTypes.array.isRequired,
  productIsInStock: PropTypes.bool.isRequired,
  dispatchResetImportCommands: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CreateBatchSuccess));
